export function getHostAppName() {
  const {
    hubspot
  } = window;
  return hubspot && hubspot.bender && typeof hubspot.bender.currentProject === 'string' ? hubspot.bender.currentProject : null;
}